import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TextAlignRightIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TextAlignRightIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TextAlignRightIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TextAlignRightIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="TextAlignRightIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M4 4h16a1 1 0 0 1 1 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1zM11 9h9a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1a1 1 0 0 1 1-1zM4 14h16a1 1 0 0 1 1 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1zM11 19h9a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1a1 1 0 0 1 1-1z"
        clipRule="evenodd"
      />
    </svg>
  )
);
TextAlignRightIcon.displayName = "TextAlignRightIcon";
export default TextAlignRightIcon;
